import moment from 'moment';
import { findIndex } from 'lodash';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps, withState } from 'recompose';

import Days from './days';
import config from '../../../config';
import { getUTCStartOfDay, prepareTimes } from '../helpers/times';
import { addBarberDay, addShopDay, removeBarberDay, removeShopDay } from '../../main/barbers/actions';
import { canUserModifySchedules } from '../helpers/users';

const formatDayForApi = day => ({
  day,
  wholeDay: true,
});

const getInsertIdx = (dates = [], dateToInsert) => {
  const idx = findIndex(dates, date => date.day >= dateToInsert);
  return idx === -1 ? dates.length : idx;
};

const mapStateToProps = state => ({
  timezone: state.auth.timezone,
  permissions: state.auth.permissions,
});

export default compose(
  withState('loadingList', 'setLoadingList', []),
  withHandlers({
    addToLoadingList: props => day => props.setLoadingList([...props.loadingList, day]),
    removeFromLoadingList: props => day => props.setLoadingList(props.loadingList.filter(item => item !== day)),
    isInLoadingList: props => day => props.loadingList.includes(day),
  }),
  withHandlers({
    createDay: (props) => {
      // fake it in create mode and for days off
      if ((!props.barberId && !props.shopId) || props.type === 'on') {
        return () => Promise.resolve();
      }

      return props.barberId ? addBarberDay.bind(null, props.barberId, props.type) : addShopDay;
    },
    removeDay: (props) => {
      // fake it in create mode and for days off
      if ((!props.barberId && !props.shopId) || props.type === 'on') {
        return () => Promise.resolve();
      }

      return props.barberId ? removeBarberDay.bind(null, props.barberId, props.type) : removeShopDay;
    },
  }),
  withHandlers({
    createDay: props => (fields, day) => {
      const isoDay = moment(day).format(config.dateFormatISO);
      props.addToLoadingList(isoDay);

      const apiDay = formatDayForApi(day);
      props.createDay(apiDay)
        .then((response) => {
          props.removeFromLoadingList(isoDay);

          let timeRange = {
            ...(response || { wholeDay: true }),
            ...prepareTimes(config.wholeDay),
          };

          if (props.type === 'on') {
            timeRange = prepareTimes(config.defaultWorkHours);
          }

          const date = getUTCStartOfDay({ day }).format();
          const idxToInsert = getInsertIdx(fields.getAll(), date);
          const dayData = {
            day: date,
            ...timeRange,
          };

          fields.insert(idxToInsert, dayData);

          if (props.onDayAdded) {
            props.onDayAdded(idxToInsert, response);
          }
        })
        .catch(() => {
          props.removeFromLoadingList(isoDay);
        });
    },
    removeDay: props => (fields, idx) => {
      const dayToRemove = fields.getAll()[idx];
      const isoDay = moment(dayToRemove.day).format(config.dateFormatISO);
      props.addToLoadingList(isoDay);
      props.removeDay(dayToRemove.id)
        .then(() => {
          fields.remove(idx);
          props.removeFromLoadingList(isoDay);

          if (props.onDayRemoved) {
            props.onDayRemoved(idx);
          }
        })
        .catch(() => props.removeFromLoadingList(isoDay));
    },
  }),
  connect(mapStateToProps, null),
  withProps(props => ({
    canModifyDays: !props.disabled && canUserModifySchedules(props.permissions),
  })),
)(Days);
